import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorMessages: null,
  errorMessagesProfile: null,
  isCreated: false,
  createdTemplate: {},
  total: 0,
};
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TYPES.GET_PRE_REGISTERED_DOCUMENTS_REQUEST:
    case TYPES.DELETE_PRE_REGISTERED_DOCUMENTS_REQUEST:
      return { ...state, fetching: true, errorFetching: false };

    case TYPES.GET_PRE_REGISTERED_DOCUMENTS_ERROR:
    case TYPES.DELETE_PRE_REGISTERED_DOCUMENTS_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };

    case TYPES.DELETE_PRE_REGISTERED_DOCUMENTS_SUCCESS: {
      const list = state.list;
      const index = list.findIndex((item) => item.id === payload.id);
      if (index !== -1) list.splice(index, 1);
      else list.push(index);
      return {
        ...state,
        list,
        fetching: false,
        total: state.total - 1,
      };
    }

    case TYPES.GET_PRE_REGISTERED_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...payload.preRegisteredDocuments],
        fetching: false,
      };
    }

    default:
      return { ...state };
  }
};

export default reducer;
